import React from "react";

const AssetsLogo = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill="#007AFF"
            d="M26.962 18a8.966 8.966 0 1 1-9.124-8.963V2C9.075 2.085 2 9.216 2 18c0 8.836 7.167 16 16 16 8.834 0 16-7.167 16-16h-7.038Z"
        />
        <path
            fill="#60B158"
            d="m17.869 17.526 4.62-2.432a.932.932 0 0 0 .035-1.63l-4.183-2.444a.931.931 0 0 0-.944 0L13.15 13.53a.932.932 0 0 0 .051 1.634l4.668 2.363Z"
        />
        <path
            fill="#FF6961"
            d="m18.24 18.153 5.003-2.62a.517.517 0 0 1 .758.459v5.573a.518.518 0 0 1-.268.454l-4.725 2.598a.519.519 0 0 1-.768-.454v-6.01Z"
        />
        <path fill="#FFA700" d="M20.848 2.001v6.985h5.89v6.058h7.26V2h-13.15Z" />
        <path
            fill="#FF6961"
            d="m17.548 18.153-5.002-2.62a.519.519 0 0 0-.759.459v5.573a.516.516 0 0 0 .268.454l4.725 2.598a.517.517 0 0 0 .768-.454v-6.01Z"
        />
    </svg>
);

export default AssetsLogo;